<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="18">
        <div class="first-title">运输流程</div>
      </el-col>
      <el-col :span="6">
        <div class="first-title">官网</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="18">
        <el-row class="_first" style="z-index: 8;">
          <!-- <transition name="bounceInLeft" appear>
            <el-col :span="4" class="_left">
              <div class="_title">
                <div class="_icon icon-yunshu">
                  <svg-icon icon-class="peoples" class-name="card-panel-icon" />
                </div>
                <div class="_txt"></div>
              </div>
            </el-col>
          </transition> -->
          <transition name="bounceInLeft" appear>
            <el-col :span="24" class="_transport">
              <div class="_group">
                <!-- <div class="_step _middle" @click="cargo_release">货源发布</div> -->
                <div class="_step _middle">货源发布</div>
              </div>
              <div class="_line">
                <i class="my-icon icon-line" />
              </div>
              <div class="_group">
                <div class="_step _middle _updown" @click="waybill_review">货源审核</div>
              </div>
              <div class="_line">
                <i class="my-icon icon-line" />
              </div>
              <div class="_group">
                <div class="_step _middle _updown" @click="order_manage">货源管理</div>
              </div>
              <div class="_line">
                <i class="my-icon icon-line" />
              </div>
              <div class="_group">
                <i class="my-icon icon-left_top" />
                <div class="_step _bottom" @click="transportation_accounting">运输核算</div>
                <i class="my-icon icon-vertical_top" />
                <div class="_step _middle" @click="waybillManage">运单管理</div>
                <i class="my-icon icon-vertical_bottom" />
                <div class="_step _top" @click="advance">预付</div>
                <i class="my-icon icon-left_bottom" />
              </div>
              <div class="_line">
                <i class="my-icon icon-line" />
              </div>
              <div class="_group">
                <div class="_step" @click="accounting">财务打款</div>
              </div>
            </el-col>
          </transition>
        </el-row>
      </el-col>
      <el-col :span="6">
        <a :href="banner.url" target="_blank">
          <div class="_website">
            <img class="_websiteImg" :src="banner.img" alt>
          </div>
        </a>
      </el-col>
    </el-row>
  </div>
</template>
 
<script>
	import {getHomeBanner} from "@/api/statistics"
export default {
  data() {
    return {
      chart: null,
      show: false,
	  banner:''
    };
  },
  created() {
	  this.getBanner()
  },
  mounted() {},
  methods: {
	  // 获取首页banner
	  getBanner(){
			 getHomeBanner().then(response => {
				this.banner = response.data[0]
			 });
	  },
    // 货源发布
    cargo_release() {
      this.$router.push({
        path: "tms/order/order_publish"
      });
    },
    // 货源审核
    waybill_review() {
      this.$router.push({
        path: "tms/order/cargoaudit"
      });
    },
	// 货源管理
	order_manage() {
	  this.$router.push({
	    path: "tms/order/order_manage"
	  });
	},
	// 运输核算
	transportation_accounting(){
		this.$router.push({
		  path: "tms/Carrier/freight"
		});
	},
    // 运单管理
    waybillManage() {
      this.$router.push({
        path: "tms/transportManage/waybillManage"
      });
    },
	// 预付
	advance(){
		this.$router.push({
		  path: "tms/advance/management"
		});
	},
    // 财务打款
    accounting() {
      this.$router.push({
        path: "tms/Carrier/MakeMoney"
      });
    }
  }
};
</script>
 
<style lang="scss" type="text/scss" scoped>
// 动画效果
.bounceInLeft-enter-active,
.bounceInLeft-leave-active {
  transition: all 1s ease;
}
.bounceInLeft-enter,
.bounceInLeft-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.first-title {
  position: relative;
  padding-left: 14px;
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 8px;
  // height: 50px;
  border-bottom: none;
  i {
    margin-right: 8px;
  }
}
.first-title::before {
  content: "";
  height: 15px;
  width: 4px;
  background-color: #ff7f21;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.first-title.noAfter::before{
	content: '';
	background-color: transparent;
}
._website {
  width: 100%;
  height: 300px;
  position: relative;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  ._txt {
    color: #666666;
    font-size: 14px;
    font-weight: 600;
    padding-left: 20px;
    position: absolute;
    top: 30px;
    left: 0;
    z-index: 9;
  }

  ._websiteImg {
    width: 100%;
    // max-width: 395px;
 	  height: 300px;
  }
}
._first {
  height: 300px;
  padding: 50px;
  box-sizing: border-box;
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
}
._left {
  // margin-right: 62px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  ._title {
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ._icon {
      margin-right: 9px;
    }
  }
  ._verticalLine {
    width: 1px;
    height: 60px;
    background: #d6dfec;
    margin: 2px 0;
    margin-left: 8px;
  }
}
._transport {
  display: flex;
  align-items: center;
  justify-content: center;
  ._group {
    position: relative;
    .icon-left_top {
      width: 125px;
      height: 60px;
      position: absolute;
      left: 110px;
      top: 18px;
      z-index: 9;
    }
	.icon-left_bottom {
	  width: 125px;
	  height: 60px;
	  position: absolute;
	  left: 110px;
	  bottom: 18px;
	  z-index: 9;
	}
	.icon-vertical_top{
		width: 5px;
		height: 40px;
		position: absolute;
		left:50%;
		transform: translateX(-50%);
		top: 40px;
		z-index: 9;
	}
	.icon-vertical_bottom{
		width: 5px;
		height: 40px;
		position: absolute;
		left:50%;
		transform: translateX(-50%);
		bottom: 40px;
		z-index: 9;
	}
    
    .icon-right_top {
      width: 102px;
      height: 56px;
      position: absolute;
      right: 108px;
      top: 25px;
      z-index: 9;
    }
    .icon-right_bottom {
      width: 102px;
      height: 56px;
      position: absolute;
      right: 108px;
      bottom: 25px;
      z-index: 9;
    }
  }
  ._step {
    width: 110px;
    height: 40px;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    white-space: nowrap;
    cursor: pointer;
    background: #43cfb3;
    color: #ffffff;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    position: relative;
    z-index: 10;
    transition: all 0.3s linear;
  }
  ._step:hover {
    background-color: #24a98e;
  }
  ._transparent {
    border: none;
    background: transparent;
  }
  ._middle {
    margin: 38px 0;
  }
  .icon-line {
    width: 71px;
    height: 6px;
  }
}
.title {
  font-size: 16px;
}

@media screen and (max-width: 1920px) {
  ._first {
	  height: 263px;
    padding: 42px;
  }
  ._left {
    // margin-right: 53px;
    ._verticalLine {
      height: 50px;
    }
    ._title {
      font-size: 13px;
      color: #333333;
    }
  }
  ._website{
	  height: 263px;
	  ._websiteImg {
	    width: 346px;
      width:100%;
	  	height: 263px;
	  }
  }
  
  ._transport {
    ._group {
      position: relative;
      .icon-left_top {
        width: 125px;
        height: 60px;
        position: absolute;
        left: 110px;
        top: 18px;
        z-index: 9;
      }
      .icon-left_bottom {
        width: 125px;
        height: 60px;
        position: absolute;
        left: 110px;
        bottom: 18px;
        z-index: 9;
      }
      .icon-right_top {
        width: 105px;
        height: 49px;
        position: absolute;
        right: 95px;
        top: 22px;
        z-index: 9;
      }
      .icon-right_bottom {
        width: 105px;
        height: 49px;
        position: absolute;
        right: 95px;
        bottom: 22px;
        z-index: 9;
      }
	  .icon-vertical_top{
	  	width: 5px;
	  	height: 38px;
	  	position: absolute;
	  	left:50%;
	  	transform: translateX(-50%);
	  	top: 38px;
	  	z-index: 9;
	  }
	  .icon-vertical_bottom{
	  	width: 5px;
	  	height: 38px;
	  	position: absolute;
	  	left:50%;
	  	transform: translateX(-50%);
	  	bottom: 38px;
	  	z-index: 9;
	  }
      ._step {
        width: 110px;
        height: 38px;
        border-radius: 18px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
      }
      ._middle {
        margin: 38px 0;
      }
    }
    .icon-line {
      width: 71px;
      height: 6px;
    }
  }
}
@media screen and (max-width: 1680px) {
  ._first {
    padding: 42px;
  }
  ._left {
    // margin-right: 53px;
    ._verticalLine {
      height: 50px;
    }
    ._title {
      font-size: 13px;
      color: #333333;
    }
  }
  ._transport {
    ._group {
      position: relative;
      .icon-left_top {
        width: 89px;
        height: 49px;
        position: absolute;
        left: 95px;
        top: 22px;
        z-index: 9;
      }
      .icon-left_bottom {
        width: 89px;
        height: 49px;
        position: absolute;
        left: 95px;
        bottom: 22px;
        z-index: 9;
      }
      .icon-right_top {
        width: 89px;
        height: 49px;
        position: absolute;
        right: 95px;
        top: 22px;
        z-index: 9;
      }
      .icon-right_bottom {
        width: 89px;
        height: 49px;
        position: absolute;
        right: 95px;
        bottom: 22px;
        z-index: 9;
      }
	  .icon-vertical_top{
	  	width: 5px;
	  	height: 33px;
	  	position: absolute;
	  	left:50%;
	  	transform: translateX(-50%);
	  	top: 35px;
	  	z-index: 9;
	  }
	  .icon-vertical_bottom{
	  	width: 5px;
	  	height: 33px;
	  	position: absolute;
	  	left:50%;
	  	transform: translateX(-50%);
	  	bottom: 35px;
	  	z-index: 9;
	  }
      ._step {
        width: 96px;
        height: 35px;
        border-radius: 18px;
        text-align: center;
        line-height: 35px;
        font-size: 14px;
      }
      ._middle {
        margin: 30px 0;
      }
    }
    .icon-line {
      width: 62px;
      height: 5px;
    }
  }
}
@media screen and (max-width: 1520px) {
  ._first {
	  height: 238px;
    padding: 30px;
  }
  ._left {
    // margin-right: 53px;
    ._verticalLine {
      height: 42px;
    }
    ._title {
      font-size: 13px;
      color: #333333;
    }
  }
  ._website{
  	  height: 238px;
  	  ._websiteImg {
  	    width: 313px;
        width:100%;
  	  	height: 238px;
  	  }
  }
  ._transport {
    ._group {
      position: relative;
      .icon-left_top {
        width: 80px;
        height: 44px;
        position: absolute;
        left: 85px;
        top: 20px;
        z-index: 9;
      }
      .icon-left_bottom {
        width: 80px;
        height: 44px;
        position: absolute;
        left: 85px;
        bottom: 20px;
        z-index: 9;
      }
      .icon-right_top {
        width: 80px;
        height: 44px;
        position: absolute;
        right: 85px;
        top: 20px;
        z-index: 9;
      }
      .icon-right_bottom {
        width: 80px;
        height: 44px;
        position: absolute;
        right: 85px;
        bottom: 20px;
        z-index: 9;
      }
	  .icon-vertical_top{
	  	width: 5px;
	  	height: 30px;
	  	position: absolute;
	  	left:50%;
	  	transform: translateX(-50%);
	  	top: 32px;
	  	z-index: 9;
	  }
	  .icon-vertical_bottom{
	  	width: 5px;
	  	height: 30px;
	  	position: absolute;
	  	left:50%;
	  	transform: translateX(-50%);
	  	bottom: 32px;
	  	z-index: 9;
	  }
      ._step {
        width: 87px;
        height: 32px;
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
      }
      ._middle {
        margin: 30px 0;
      }
    }
    .icon-line {
      width: 56px;
      height: 5px;
    }
  }
}
@media screen and (max-width: 1440px) {
  ._first {
	  height: 225px;
    padding: 16px;
  }
  ._website{
  	  height: 225px;
  	  ._websiteImg {
  	    width: 296px;
        width:100%;
  	  	height: 225px;
  	  }
  }
}
</style>
